import React from 'react';
import clsx from 'clsx';

// Components

import Input from './fields/Input';
import BirthdayPicker from './fields/BirthdayPicker/BirthdayPicker';
import CountrySelect from './fields/CountrySelect';
import PhoneInput from '../components/fields/PhoneInput';
import NationalPersonNumberField from './fields/NationalPersonNumberField';

// Translations
import personalInfoMessages from '../views/PersonalInfo/messages';

// Icon
import { PassengerDataFormProps } from '../models/PassengerDataFormProps';
import SearchIcon from '../assets/icons/search-icon.inline.svg';

const fieldNameToComponentMap = {
  first_name: (
    <Input
      name="first_name"
      type="text"
      label={personalInfoMessages.firstName}
      placeholder={personalInfoMessages.firstNamePlaceholder}
    />
  ),
  last_name: (
    <Input
      wrapperClassName="mt-25 sm:mt-0"
      name="last_name"
      type="text"
      label={personalInfoMessages.lastName}
      placeholder={personalInfoMessages.lastNamePlaceholder}
    />
  ),
  address: (
    <Input
      name="address"
      label={personalInfoMessages.address}
      placeholder={personalInfoMessages.addressPlaceholder}
    />
  ),
  postal_code: (
    <Input
      name="postal_code"
      label={personalInfoMessages.postalCode}
      placeholder={personalInfoMessages.postalCodePlaceholder}
    />
  ),
  phone: (
    <PhoneInput
      name="phone_number"
      label={personalInfoMessages.phone}
      placeholder={personalInfoMessages.phonePlaceholder}
      portal={null}
      locale={null}
    />
  ),
  city: (
    <Input
      name="city"
      label={personalInfoMessages.city}
      placeholder={personalInfoMessages.cityPlaceholder}
    />
  ),
  country_id: (
    <CountrySelect
      name="country_id"
      label={personalInfoMessages.country}
      placeholder={personalInfoMessages.countryPlaceholder}
      icon={<SearchIcon />}
      code={null}
      hideIconOnValue={true}
      prefillWithFirstOption={true}
    />
  ),
  date_of_birth: (
    <BirthdayPicker
      name="date_of_birth"
      autoComplete="off"
      label={personalInfoMessages.birthDate}
    />
  ),
  city_of_birth: (
    <Input
      name="city_of_birth"
      label={personalInfoMessages.cityOfBirth}
      placeholder={personalInfoMessages.cityOfBirthPlaceholder}
    />
  ),
  country_of_birth_id: (
    <CountrySelect
      name="country_of_birth_id"
      label={personalInfoMessages.countryOfBirth}
      placeholder={personalInfoMessages.countryOfBirthPlaceholder}
      icon={<SearchIcon />}
      code={null}
      hideIconOnValue={true}
      prefillWithFirstOption={true}
    />
  ),
  national_personal_number: (
    <NationalPersonNumberField
      name="national_personal_number"
      label={personalInfoMessages.nationalIdNumber}
      placeholder={personalInfoMessages.nationalIdNumberPlaceholder}
    />
  ),
  passport_document_number: (
    <Input
      name="passport_document_number"
      label={personalInfoMessages.idDocumentNumber}
      placeholder={personalInfoMessages.idDocumentNumberPlaceholder}
    />
  ),
  occupation: (
    <Input
      name="occupation"
      label={personalInfoMessages.occupation}
      placeholder={personalInfoMessages.occupationPlaceholder}
    />
  ),
  fiscal_code: (
    <Input
      name="fiscal_code"
      label={personalInfoMessages.fiscalCode}
      placeholder={personalInfoMessages.fiscalCodePlaceholder}
    />
  ),
};

const PassengerDataForm = (props: PassengerDataFormProps) => {
  const { chunkedFields, alertComponent, disabled, children } = props;
  return (
    <div>
      <>
        {chunkedFields?.length
          ? chunkedFields?.map((chunk: string[], index: number) => {
              const first =
                chunk[0] && fieldNameToComponentMap[chunk[0]]
                  ? React.cloneElement(fieldNameToComponentMap[chunk[0]], {
                      disabled,
                    })
                  : null;
              const second =
                chunk[1] && fieldNameToComponentMap[chunk[1]]
                  ? React.cloneElement(fieldNameToComponentMap[chunk[1]], {
                      disabled,
                    })
                  : null;
              return (
                <div
                  // eslint-disable-next-line
                  key={`chunk-${index}`}
                  className={clsx(`fieldset sm:flex-row`, {
                    ['sm:mt-18']: index === 0,
                    ['mt-25']: index > 0,
                    ['mb-35']: index === chunkedFields.length - 1,
                  })}
                >
                  {first}
                  {second}
                </div>
              );
            })
          : null}
        {children}
        {alertComponent}
      </>
    </div>
  );
};

PassengerDataForm.defaultProps = {
  alertComponent: null,
};

export default PassengerDataForm;
